import { freeze } from '@reduxjs/toolkit';
import { appRoutes, ISidebarLink } from '../../../path';
import { PermissionKey } from '../../../utils/apollo/graphqlSchema';

export const dictionaryWarehouseDataNavLinks = freeze<ISidebarLink[]>(
  [
    {
      title: 'Event',
      url: appRoutes.dictionary.event,
      tooltip: {
        content: `View and manage all Events.`,
      },
      permissionKeys: [PermissionKey.EventRead],
    },
    {
      title: 'Field',
      url: appRoutes.dictionary.field,
      tooltip: {
        content: `View and manage all Fields.`,
      },
      permissionKeys: [PermissionKey.FieldRead],
    },
  ],
  true,
);

export const dictionaryCustomDataNavLinks = freeze<ISidebarLink[]>(
  [
    {
      title: 'Measure',
      url: appRoutes.dictionary.measure,
      tooltip: {
        content: `View all saved Measures, which are defined as a Function over some Events with Event Filters.`,
        actionText: 'Learn More',
        actionUrl: `https://docs.kubit.ai/docs/query#building-your-measures`,
      },
      permissionKeys: [PermissionKey.MeasureRead],
    },
    {
      title: 'Virtual Event',
      url: appRoutes.dictionary.virtualEvent,
      tooltip: {
        content: `View and manage all Virtual Events.`,
      },
      permissionKeys: [PermissionKey.VirtualEventRead],
    },
    {
      title: 'Filter',
      url: appRoutes.dictionary.filter,
      tooltip: {
        content: `View and manage all Filters.`,
      },
      permissionKeys: [PermissionKey.FilterRead],
    },
    {
      title: 'Binning',
      url: appRoutes.dictionary.buckets,
      tooltip: {
        content: `View and manage all Bins.`,
      },
      permissionKeys: [PermissionKey.BucketDefRead],
    },
  ],
  true,
);
